import React from "react";

const FaqThree = () => {
  return (
    <section className='d-flex overflow-hidden position-relative overflow-hidden'>
      <img
        src='assets/images/shapes/shape1.png'
        alt=''
        className='animation-rotation flex-shrink-0 position-absolute inset-block-end-25-percent inset-inline-start-34-percent z-n1'
      />
      <img
        src='assets/images/shapes/shape5.png'
        alt=''
        className='animation-walking flex-shrink-0 position-absolute inset-inline-start-10-persent inset-block-start-30-persent z-n1'
      />
      <img
        src='assets/images/shapes/shape3.png'
        alt=''
        className='animation-walking flex-shrink-0 position-absolute inset-inline-end-13-persent inset-block-start-10-persent z-n1'
      />
      <img
        src='../../assets/images/shapes/curve-arrow.png'
        alt=''
        className='animate__wobble__two flex-shrink-0 position-absolute inset-block-end-8-persent inset-inline-end-8-persent z-n1'
      />
      <div className='container'>
        <div className='row align-items-center'>
          <div
            className='col-lg-6 wow bounceIn flex-shrink-0'
            data-wow-duration='3s'
          >
          </div>
          <div className='col-lg-6'>
            <div className='py-120 max-w-526-px lg-ms-134px'>
              <div className='faq-content'>
                <div className='mb-40'>
                  <div className='flex-align d-inline-flex flex-wrap gap-8 mb-16 wow bounceInDown'>
                    <span className='text-main-600 text-2xl d-flex'>
                      <i className='ph-bold ph-question' />
                    </span>
                    <h5 className='text-main-600 mb-0'>
                      Pertanyaan Yang Sering Diajukan
                    </h5>
                  </div>
                  <h2 className='mb-24 wow bounceIn'>
                    Informasi Lengkap Les Privat Bimbel Kusuma
                  </h2>
                  <p className='text-neutral-500 text-line-2 wow bounceInUp'>
                    Temukan jawaban untuk pertanyaan umum seputar layanan les privat Bimbel Kusuma di Kudus, Pati, Jepara, dan Solo Raya.
                  </p>
                </div>
                <div
                  className='accordion common-accordion'
                  id='accordionExample'
                >
                  <div
                    className='accordion-item'
                    data-aos='fade-up-left'
                    data-aos-duration={400}
                  >
                    <h2 className='accordion-header'>
                      <button
                        className='accordion-button'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapseOne'
                        aria-expanded='true'
                        aria-controls='collapseOne'
                      >
                        Bagaimana cara mendaftar les privat di Bimbel Kusuma?
                      </button>
                    </h2>
                    <div
                      id='collapseOne'
                      className='accordion-collapse collapse show'
                      data-bs-parent='#accordionExample'
                    >
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Pendaftaran les privat di Bimbel Kusuma dapat dilakukan melalui WhatsApp ke nomor 0821-3156-9957 atau melalui link pendaftaran di website kami. Tim kami akan segera menghubungi Anda untuk konfirmasi jadwal dan penempatan guru.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className='accordion-item'
                    data-aos='fade-up-left'
                    data-aos-duration={600}
                  >
                    <h2 className='accordion-header'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapseTwo'
                        aria-expanded='false'
                        aria-controls='collapseTwo'
                      >
                        Berapa lama durasi setiap pertemuan les privat?
                      </button>
                    </h2>
                    <div
                      id='collapseTwo'
                      className='accordion-collapse collapse'
                      data-bs-parent='#accordionExample'
                    >
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Setiap pertemuan les privat berlangsung selama 1,5 Jam, dengan sistem guru datang ke rumah. Jadwal dapat disesuaikan dengan kesepakatan antara siswa dan guru.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className='accordion-item'
                    data-aos='fade-up-left'
                    data-aos-duration={800}
                  >
                    <h2 className='accordion-header'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapseThree'
                        aria-expanded='false'
                        aria-controls='collapseThree'
                      >
                        Apakah guru-guru Bimbel Kusuma berpengalaman?
                      </button>
                    </h2>
                    <div
                      id='collapseThree'
                      className='accordion-collapse collapse'
                      data-bs-parent='#accordionExample'
                    >
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Ya, Bimbel Kusuma memiliki 330 guru professional yang telah terseleksi dan berpengalaman dalam bidangnya masing-masing. Semua guru kami siap memberikan pendampingan belajar berkualitas.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className='accordion-item'
                    data-aos='fade-up-left'
                    data-aos-duration={1000}
                  >
                    <h2 className='accordion-header'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapseFour'
                        aria-expanded='false'
                        aria-controls='collapseFour'
                      >
                        Program les privat apa saja yang tersedia?
                      </button>
                    </h2>
                    <div
                      id='collapseFour'
                      className='accordion-collapse collapse'
                      data-bs-parent='#accordionExample'
                    >
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Kami menyediakan program les privat untuk semua jenjang pendidikan, mulai dari TK, SD, SMP, SMA/SMK hingga program umum.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div
                    className='accordion-item'
                    data-aos='fade-up-left'
                    data-aos-duration={1200}
                  >
                    <h2 className='accordion-header'>
                      <button
                        className='accordion-button collapsed'
                        type='button'
                        data-bs-toggle='collapse'
                        data-bs-target='#collapseFive'
                        aria-expanded='false'
                        aria-controls='collapseFive'
                      >
                        Di mana saja area layanan Bimbel Kusuma?
                      </button>
                    </h2>
                    <div
                      id='collapseFive'
                      className='accordion-collapse collapse'
                      data-bs-parent='#accordionExample'
                    >
                      <div className='accordion-body'>
                        <p className='accordion-body__desc'>
                          Bimbel Kusuma melayani les privat di wilayah Kudus, Pati, Jepara, dan Solo Raya dengan 10 cabang yang tersebar di berbagai lokasi strategis.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FaqThree;
